const PmiStructureEnum = Object.freeze({
    AIF: 'AIF',
    CAYMAN_LP: 'CAYMAN_LP',
    DELAWARE_LLC: 'DELAWARE_LLC',
    ELTIF: 'ELTIF',
    FUND: 'FUND',
    LIMITED_PARTNERSHIP: 'LIMITED_PARTNERSHIP',
    LTAF: 'LTAF',
    PRODUCT: 'PRODUCT',
    SICAV: 'SICAV',
    SICAV_RAIF: 'SICAV_RAIF',
    SINGAPORE_VCC: 'SINGAPORE_VCC',
    UNIT_TRUST: 'UNIT_TRUST'
});

export default PmiStructureEnum;
